import * as $runtime from "../runtime.js";
import * as Control$dMonad$dExcept$dTrans from "../Control.Monad.Except.Trans/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dNullable from "../Data.Nullable/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dIndex from "../Foreign.Index/index.js";
import * as Halogen$dQuery$dInput from "../Halogen.Query.Input/index.js";
import * as Halogen$dVDom$dDOM$dProp from "../Halogen.VDom.DOM.Prop/index.js";
import * as Web$dEvent$dEvent from "../Web.Event.Event/index.js";
import * as Web$dFile$dFileList from "../Web.File.FileList/index.js";
import * as Web$dHTML$dHTMLInputElement from "../Web.HTML.HTMLInputElement/index.js";
import * as Web$dInternal$dFFI from "../Web.Internal.FFI/index.js";
const readProp = /* #__PURE__ */ Foreign$dIndex.unsafeReadProp(Data$dIdentity.monadIdentity);
const handler$p = et => f => Halogen$dVDom$dDOM$dProp.$Prop(
  "Handler",
  et,
  ev => {
    const $0 = f(ev);
    if ($0.tag === "Just") { return Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", $0._1)); }
    return Data$dMaybe.Nothing;
  }
);
const handler = et => f => Halogen$dVDom$dDOM$dProp.$Prop("Handler", et, ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", f(ev))));
const onAbort = f => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "abort", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", f(ev))));
const onAuxClick = x => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "auxclick", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", x(ev))));
const onChange = f => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "change", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", f(ev))));
const onClick = x => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "click", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", x(ev))));
const onDoubleClick = x => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "dblclick", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", x(ev))));
const onError = f => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "error", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", f(ev))));
const onFileUpload = dictUnfoldable => {
  const none = dictUnfoldable.unfoldr(v => Data$dMaybe.Nothing)();
  return f => Halogen$dVDom$dDOM$dProp.$Prop(
    "Handler",
    "change",
    ev => Data$dMaybe.$Maybe(
      "Just",
      Halogen$dQuery$dInput.$Input(
        "Action",
        (() => {
          const $0 = Data$dNullable.nullable(Web$dEvent$dEvent._target(ev), Data$dMaybe.Nothing, Data$dMaybe.Just);
          const $1 = (() => {
            if ($0.tag === "Just") {
              const $1 = Web$dInternal$dFFI._unsafeReadProtoTagged(Data$dMaybe.Nothing, Data$dMaybe.Just, "HTMLInputElement", $0._1);
              if ($1.tag === "Just") {
                return (() => {
                  const $2 = Web$dHTML$dHTMLInputElement._files($1._1);
                  return () => {
                    const a$p = $2();
                    return Data$dNullable.nullable(a$p, Data$dMaybe.Nothing, Data$dMaybe.Just);
                  };
                })()();
              }
              if ($1.tag === "Nothing") { return Data$dMaybe.Nothing; }
              $runtime.fail();
            }
            if ($0.tag === "Nothing") { return Data$dMaybe.Nothing; }
            $runtime.fail();
          })();
          return f((() => {
            if ($1.tag === "Nothing") { return none; }
            if ($1.tag === "Just") { return Web$dFile$dFileList.items(dictUnfoldable)($1._1); }
            $runtime.fail();
          })());
        })()
      )
    )
  );
};
const onInput = f => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "input", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", f(ev))));
const onInvalid = f => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "invalid", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", f(ev))));
const onKeyDown = x => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "keydown", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", x(ev))));
const onKeyUp = x => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "keyup", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", x(ev))));
const onLoad = f => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "load", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", f(ev))));
const onMouseDown = x => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "mousedown", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", x(ev))));
const onMouseEnter = x => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "mouseenter", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", x(ev))));
const onMouseLeave = x => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "mouseleave", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", x(ev))));
const onMouseMove = x => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "mousemove", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", x(ev))));
const onMouseOut = x => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "mouseout", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", x(ev))));
const onMouseOver = x => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "mouseover", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", x(ev))));
const onMouseUp = x => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "mouseup", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", x(ev))));
const onReset = f => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "reset", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", f(ev))));
const onResize = f => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "resize", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", f(ev))));
const onScroll = f => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "scroll", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", f(ev))));
const onSelect = f => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "select", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", f(ev))));
const onSubmit = f => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "submit", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", f(ev))));
const onTouchCancel = x => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "touchcancel", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", x(ev))));
const onTouchEnd = x => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "touchend", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", x(ev))));
const onTouchEnter = x => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "touchenter", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", x(ev))));
const onTouchLeave = x => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "touchleave", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", x(ev))));
const onTouchMove = x => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "touchmove", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", x(ev))));
const onTouchStart = x => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "touchstart", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", x(ev))));
const onTransitionEnd = f => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "transitionend", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", f(ev))));
const onWheel = x => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "wheel", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", x(ev))));
const onBlur = x => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "blur", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", x(ev))));
const onFocus = x => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "focus", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", x(ev))));
const onFocusIn = x => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "focusin", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", x(ev))));
const onFocusOut = x => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "focusout", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", x(ev))));
const onDrag = x => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "drag", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", x(ev))));
const onDragEnd = x => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "dragend", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", x(ev))));
const onDragEnter = x => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "dragenter", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", x(ev))));
const onDragExit = x => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "dragexit", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", x(ev))));
const onDragLeave = x => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "dragleave", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", x(ev))));
const onDragOver = x => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "dragover", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", x(ev))));
const onDragStart = x => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "dragstart", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", x(ev))));
const onDrop = x => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "drop", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", x(ev))));
const onCopy = x => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "copy", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", x(ev))));
const onCut = x => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "cut", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", x(ev))));
const onPaste = x => Halogen$dVDom$dDOM$dProp.$Prop("Handler", "paste", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", x(ev))));
const addForeignPropHandler = key => prop => reader => f => Halogen$dVDom$dDOM$dProp.$Prop(
  "Handler",
  key,
  ev => {
    const $0 = Data$dNullable.nullable(Web$dEvent$dEvent._currentTarget(ev), Data$dMaybe.Nothing, Data$dMaybe.Just);
    if ($0.tag === "Just") {
      const $1 = Control$dMonad$dExcept$dTrans.bindExceptT(Data$dIdentity.monadIdentity).bind(readProp(prop)($0._1))(reader);
      if ($1.tag === "Left") { return Data$dMaybe.Nothing; }
      if ($1.tag === "Right") { return Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", f($1._1))); }
      $runtime.fail();
    }
    if ($0.tag === "Nothing") { return Data$dMaybe.Nothing; }
    $runtime.fail();
  }
);
const onChecked = /* #__PURE__ */ addForeignPropHandler("change")("checked")(/* #__PURE__ */ Foreign.readBoolean(Data$dIdentity.monadIdentity));
const onSelectedIndexChange = /* #__PURE__ */ addForeignPropHandler("change")("selectedIndex")(/* #__PURE__ */ Foreign.readInt(Data$dIdentity.monadIdentity));
const onValueChange = /* #__PURE__ */ addForeignPropHandler("change")("value")(/* #__PURE__ */ Foreign.readString(Data$dIdentity.monadIdentity));
const onValueInput = /* #__PURE__ */ addForeignPropHandler("input")("value")(/* #__PURE__ */ Foreign.readString(Data$dIdentity.monadIdentity));
export {
  addForeignPropHandler,
  handler,
  handler$p,
  onAbort,
  onAuxClick,
  onBlur,
  onChange,
  onChecked,
  onClick,
  onCopy,
  onCut,
  onDoubleClick,
  onDrag,
  onDragEnd,
  onDragEnter,
  onDragExit,
  onDragLeave,
  onDragOver,
  onDragStart,
  onDrop,
  onError,
  onFileUpload,
  onFocus,
  onFocusIn,
  onFocusOut,
  onInput,
  onInvalid,
  onKeyDown,
  onKeyUp,
  onLoad,
  onMouseDown,
  onMouseEnter,
  onMouseLeave,
  onMouseMove,
  onMouseOut,
  onMouseOver,
  onMouseUp,
  onPaste,
  onReset,
  onResize,
  onScroll,
  onSelect,
  onSelectedIndexChange,
  onSubmit,
  onTouchCancel,
  onTouchEnd,
  onTouchEnter,
  onTouchLeave,
  onTouchMove,
  onTouchStart,
  onTransitionEnd,
  onValueChange,
  onValueInput,
  onWheel,
  readProp
};
